export default "__VITE_ASSET__DV1$J1dx__"